"use strict";

var STATE_KEY = "__modalOpen";
var MODAL_SELECTOR =
    "#deliverySelectorModal, #cartHomeDeliveryModal, #cartPickupPointModal, #cartStoreSelectorModal, #storeSelectorModal";
var POP_DELAY_MS = 120;

var openCount = 0;
var ownsEntry = false;
var ignoreNextPopstate = false;
var popTimer = null;
var unloading = false;

function hasOurState() {
    return !!(window.history.state && window.history.state[STATE_KEY]);
}

function onUnload() {
    unloading = true;
    clearTimeout(popTimer);
}

function onShown() {
    unloading = false;
    openCount += 1;
    clearTimeout(popTimer);

    if (!ownsEntry) {
        var state = {};

        state[STATE_KEY] = true;
        window.history.pushState(state, "", window.location.href);
        ownsEntry = true;
    }
}

function onHidden() {
    openCount = Math.max(0, openCount - 1);

    if (openCount > 0 || !ownsEntry) {
        return;
    }

    // Diferido: si se abre otro modal enseguida se reutiliza la misma entrada.
    popTimer = setTimeout(function () {
        if (unloading || openCount !== 0 || !ownsEntry) {
            return;
        }

        ownsEntry = false;

        if (hasOurState()) {
            ignoreNextPopstate = true;
            window.history.back();
        }
    }, POP_DELAY_MS);
}

function onPopstate(e) {
    // popstate provocado por nuestro propio history.back(): no es de nadie más.
    if (ignoreNextPopstate) {
        ignoreNextPopstate = false;
        e.stopImmediatePropagation();
        return;
    }

    // El usuario apretó "atrás" con un modal abierto: se cierra el modal.
    if (ownsEntry && openCount > 0 && !(e.state && e.state[STATE_KEY])) {
        ownsEntry = false;
        e.stopImmediatePropagation();
        $(MODAL_SELECTOR).filter(".show").modal("hide");
    }
}

/**
 * Registra el comportamiento. Llamar UNA vez, lo antes posible: antes de que
 * cualquier otro código registre listeners de popstate.
 * @returns {void}
 */
function init() {
    window.addEventListener("popstate", onPopstate);
    window.addEventListener("beforeunload", onUnload);

    $(document)
        .on("shown.bs.modal", MODAL_SELECTOR, onShown)
        .on("hidden.bs.modal", MODAL_SELECTOR, onHidden);
}

module.exports = {
    init: init
};